import API_URL from "../config/ApiUrl";
export const researchAPI = {
  // Fetch articles with filters
  async getArticles(params = {}) {
    const queryParams = new URLSearchParams({
      page: params.page || 1,
      per_page: params.per_page || 10, // Changed default to 10
      category: params.category || 'all',
      search: params.search || '',
      sort_by: params.sort_by || 'hot',
      tag: params.tag || ''
    });

    const response = await fetch(`${API_URL}/articles?${queryParams}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Get featured article
  async getFeaturedArticle() {
    const response = await fetch(`${API_URL}/articles/featured`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Get article details
  async getArticleDetails(articleId) {
    const response = await fetch(`${API_URL}/articles/${articleId}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Get research stats
  async getStats() {
    const response = await fetch(`${API_URL}/stats`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Get categories
  async getCategories() {
    const response = await fetch(`${API_URL}/categories`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Submit research
  async submitResearch(formData) {
    const response = await fetch(`${API_URL}/api/research/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    return data;
  },

   async  submitResearchArticle(formData)  {
    const response = await fetch(`${API_URL}/api/research/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Add this line to include cookies/session
      body: JSON.stringify(formData),
    });
  
    const data = await response.json();
  
    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }
  
    return data;
  },
  
  async getArticleDiscussions(articleId, params = {}) {
    const queryParams = new URLSearchParams({
      page: params.page || 1,
      per_page: params.per_page || 20,
      sort_by: params.sort_by || 'newest' // newest, oldest, popular, pinned
    });

    const response = await fetch(`${API_URL}/articles/${articleId}/discussions?${queryParams}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Get replies for a specific discussion
  async getDiscussionReplies(discussionId) {
    const response = await fetch(`${API_URL}/discussions/${discussionId}/replies`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Create a new discussion (comment)
  async createDiscussion(articleId, content) {
    const response = await fetch(`${API_URL}/articles/${articleId}/discussions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ content }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    return data;
  },

  // Create a reply to a discussion
  async createReply(discussionId, content, parentReplyId = null) {
    const response = await fetch(`${API_URL}/discussions/${discussionId}/replies`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ 
        content,
        parent_reply_id: parentReplyId 
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    return data;
  },

  // Toggle like on a discussion
  async toggleDiscussionLike(discussionId) {
    const response = await fetch(`${API_URL}/discussions/${discussionId}/like`, {
      method: 'POST',
      credentials: 'include'
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    return data;
  },

  // Toggle like on a reply
  async toggleReplyLike(replyId) {
    const response = await fetch(`${API_URL}/replies/${replyId}/like`, {
      method: 'POST',
      credentials: 'include'
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    return data;
  },

  // Get article statistics and engagement data
  async getArticleStats(articleId) {
    const response = await fetch(`${API_URL}/articles/${articleId}/stats`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  // Get trending topics/tags
  async getTrendingTopics() {
    const response = await fetch(`${API_URL}/trending-topics`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
},
  async voteArticle(articleId, voteType) {
  const response = await fetch(`${API_URL}/articles/${articleId}/vote`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ vote_type: voteType }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }

  return data;
},
async getRelatedArticles(articleId) {
  const response = await fetch(`${API_URL}/articles/${articleId}/related`, {
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
},
async getUserArticleVotes() {
  const response = await fetch(`${API_URL}/user/article-votes`, {
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
},
async toggleDiscussionDislike(discussionId)  {
  const response = await fetch(`${API_URL}/api/discussions/${discussionId}/dislike`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to toggle dislike');
  }
  
  return response.json();
},

async toggleReplyVote(replyId, value) {
  const response = await fetch(`${API_URL}/api/replies/${replyId}/vote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ value: value })
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }
  return data;
},

async toggleReplyDislike(replyId) {
  const response = await fetch(`${API_URL}/api/replies/${replyId}/dislike`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include'
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }
  return data;
},

async trackArticleView(articleId) {
  try {
    const response = await fetch(`${API_URL}/articles/${articleId}/view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      console.warn(`Failed to track view for article ${articleId}`);
      return false;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.warn('Error tracking article view:', error);
    return false;
  }
},
};
